<p>{{ 'LOGISTIC-ORDER/dialog/token/link' | translate }}:</p>
<p style="word-wrap: break-word;"><a [href]="this.data.link">{{this.data.link}}</a></p>
<div mat-dialog-actions>
   <button mat-button class="primary-button" (click)="onClickOk()" cdkFocusInitial>{{ 'SITE_INVESTIGATION/dialog/btn/ok' | translate }}</button>
</div>
